const STORAGE_KEY = "pittroff:polish";
const CLASS_NAME = "polish-enabled";
const SECTION_PACING_CLASS_NAME = "polish-section-pacing";
const CAPTIONS_CLASS_NAME = "polish-captions";
const ALTERNATE_COLUMNS_CLASS_NAME = "polish-alternate-columns";
const DEFAULT_ENABLED = true;
const PROJECT_INDEX_PAGE_CLASS_NAME = "page-project-index";

function readUrlSetting() {
  const params = new URLSearchParams(window.location.search);
  const value = params.get("polish");

  if (value === "1" || value === "true" || value === "on") {
    return true;
  }

  if (value === "0" || value === "false" || value === "off") {
    return false;
  }

  return null;
}

function readUrlFlag(name) {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(name);

  return value === "1" || value === "true" || value === "on";
}

function persistSetting(enabled) {
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch (error) {
    // Ignore storage failures in locked-down browsers.
  }
}

function readStoredSetting() {
  return DEFAULT_ENABLED;
}

function applySetting(enabled) {
  document.documentElement.classList.toggle(CLASS_NAME, enabled);
  window.pittroffPolishEnabled = enabled;
}

function applySectionPacing(enabled) {
  document.documentElement.classList.toggle(SECTION_PACING_CLASS_NAME, enabled);
  window.pittroffPolishSectionPacingEnabled = enabled;
}

function applyCaptions(enabled) {
  document.documentElement.classList.toggle(CAPTIONS_CLASS_NAME, enabled);
  window.pittroffPolishCaptionsEnabled = enabled;
}

function applyAlternateColumns(enabled) {
  document.documentElement.classList.toggle(
    ALTERNATE_COLUMNS_CLASS_NAME,
    enabled
  );
  window.pittroffPolishAlternateColumnsEnabled = enabled;
}

function applyProjectIndexDefaults() {
  if (!document.body?.classList.contains(PROJECT_INDEX_PAGE_CLASS_NAME)) {
    return;
  }

  if (!document.documentElement.classList.contains(CLASS_NAME)) {
    return;
  }

  applySectionPacing(true);
  applyAlternateColumns(true);
}

function initProjectIndexDefaults() {
  applyProjectIndexDefaults();

  if (!document.body) {
    document.addEventListener("DOMContentLoaded", applyProjectIndexDefaults, {
      once: true,
    });
  }
}

function setPolishMode(enabled, options = {}) {
  const nextValue = Boolean(enabled);

  applySetting(nextValue);

  if (options.persist !== false) {
    persistSetting(nextValue);
  }

  return nextValue;
}

function setSectionPacing(enabled) {
  const nextValue = Boolean(enabled);

  applySectionPacing(nextValue);

  if (nextValue) {
    setPolishMode(true, { persist: false });
  }

  return nextValue;
}

function setCaptions(enabled) {
  const nextValue = Boolean(enabled);

  applyCaptions(nextValue);

  if (nextValue) {
    setPolishMode(true, { persist: false });
  }

  return nextValue;
}

function setAlternateColumns(enabled) {
  const nextValue = Boolean(enabled);

  applyAlternateColumns(nextValue);

  if (nextValue) {
    setPolishMode(true, { persist: false });
  }

  return nextValue;
}

export function initPolishToggle() {
  const urlSetting = readUrlSetting();
  const alternateColumnsEnabled = readUrlFlag("alternate");
  const initialSetting =
    urlSetting === null ? readStoredSetting() : setPolishMode(urlSetting);

  applySetting(initialSetting);
  applySectionPacing(false);
  applyCaptions(true);
  applyAlternateColumns(alternateColumnsEnabled);
  initProjectIndexDefaults();

  window.PittroffPolish = {
    enable() {
      return setPolishMode(true);
    },
    disable() {
      return setPolishMode(false);
    },
    toggle() {
      return setPolishMode(
        !document.documentElement.classList.contains(CLASS_NAME)
      );
    },
    status() {
      return document.documentElement.classList.contains(CLASS_NAME);
    },
    enableSectionPacing() {
      return setSectionPacing(true);
    },
    disableSectionPacing() {
      return setSectionPacing(false);
    },
    enableCaptions() {
      return setCaptions(true);
    },
    disableCaptions() {
      return setCaptions(true);
    },
    enableAlternateColumns() {
      return setAlternateColumns(true);
    },
    disableAlternateColumns() {
      return setAlternateColumns(false);
    },
  };
}
